import { useEffect, useState } from 'react';

interface VersionInfo {
  version: string;
  timestamp: number;
}

export default function VersionChecker() {
  const [currentVersion, setCurrentVersion] = useState<string | null>(null);

  useEffect(() => {
    // Charger la version initiale
    const loadInitialVersion = async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now());
        const data: VersionInfo = await response.json();
        setCurrentVersion(data.version);
      } catch (error) {
        // Erreur silencieuse
      }
    };

    loadInitialVersion();

    // Vérifier les mises à jour toutes les 30 secondes
    const checkInterval = setInterval(async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now());
        const data: VersionInfo = await response.json();

        if (currentVersion && data.version !== currentVersion) {
          // Arrêter la vérification
          clearInterval(checkInterval);

          // Attendre 10 secondes puis reload automatiquement
          setTimeout(() => {
            window.location.reload();
          }, 10000); // 10 secondes de délai
        }
      } catch (error) {
        // Erreur silencieuse
      }
    }, 30000); // Vérifier toutes les 30 secondes

    return () => clearInterval(checkInterval);
  }, [currentVersion]);

  // Pas de UI - tout se passe en arrière-plan
  return null;
}
